import DashboardLayout from '../../common/DashboardLayout';

/**
 * Test page to demonstrate the mega menu with top navbar layout
 * Access at: /admin/test-mega-menu
 */
const TestMegaMenu = () => {
  return (
    <DashboardLayout 
      role="admin" 
      layoutType="topnav"
      activeMenu="Test"
      showBreadcrumbs={false}
    >
      <div style={{ padding: '24px' }}>
        <h1>Mega Menu Test Page</h1>
        <p>This page demonstrates the new top navbar with mega menu.</p>
        <p>Hover over the navigation items in the top navbar to see the mega menus.</p>
        
        <div style={{ marginTop: '32px', padding: '24px', background: '#f7fafc', borderRadius: '8px' }}>
          <h2>Features:</h2>
          <ul>
            <li>Multi-column mega menu dropdowns</li>
            <li>Hover activation on desktop</li>
            <li>Icons and descriptions for each menu item</li>
            <li>Responsive design (mobile accordion)</li>
            <li>User menu dropdown</li>
          </ul>
        </div>

        <div style={{ marginTop: '32px', padding: '24px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
          <h3>Try it out:</h3>
          <p>Hover over &quot;User Management&quot;, &quot;Content&quot;, or &quot;Analytics&quot; in the top navbar to see the mega menus.</p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default TestMegaMenu;

